import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "base-module__title" }

import { NCard, NSpace, NGrid, NGridItem, NAlert } from 'naive-ui'
import { BfButton } from '@finetic/bikefitting-ui'
import { Icon } from '@iconify/vue'

import { ref, onMounted, onUnmounted, useSlots, watch, computed } from 'vue'
import { MqttValue, MqttContainer } from '@/mqttDefinitions'
import { useMqttStore } from '@/store/mqttStore'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { arrayEquals } from '@/utils/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModule',
  props: {
    installed: { type: Boolean, default: true },
    inactive: { type: Boolean, default: false },
    connected: { type: Boolean, default: false },
    connecting: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    contentActive: { type: Boolean, default: true },
    useActive: { type: Boolean, default: false },
    definition: { default: undefined }
  },
  setup(__props: any) {

const { t } = useI18n()

const mqttStore = useMqttStore()
const slots = useSlots()

const { doSubscribe, doUnSubscribe, getTopicsFromDefinition } = mqttStore
const { client } = storeToRefs(mqttStore)

const topics = ref([] as string[])

let timeoutId: ReturnType<typeof setTimeout>

const moduleMessages = computed(() => {
  return mqttStore.getMessagesOnTopics(topics.value)
})

const props = __props

const listening = ref(false)
const isActive = ref(false)

const subscribeToTopics = () => {
  topics.value.forEach(async (topic) => {
    listening.value = await doSubscribe(topic, client.value)
  })
}

onMounted(() => {
  if (props.definition && props.installed) {
    topics.value = getTopicsFromDefinition(props.definition)
    subscribeToTopics()
  }
})

onUnmounted(() => {
  topics.value.forEach((topic) => {
    doUnSubscribe(topic, client.value)
  })
})

watch(moduleMessages, (newMessages, oldMessages) => {
  if (!arrayEquals(newMessages, oldMessages) && props.useActive) {
    isActive.value = true
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      isActive.value = false
    }, 60000)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NCard), {
    class: _normalizeClass({ 'base-module--disabled': __props.inactive })
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NGrid), {
        cols: 6,
        "x-gap": "24",
        "y-gap": "24",
        "item-responsive": "",
        responsive: "screen"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NGridItem), { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSpace), {
                align: "center",
                justify: "space-between",
                size: 16
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    align: "center",
                    size: 16
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                'base-module__status',
                { 'base-module__status--inactive': !__props.installed },
                { 'base-module__status--connected': __props.connected && !__props.connecting },
                { 'base-module__status--connecting': __props.connecting },
                { 'base-module__status--error': __props.error },
                { 'base-module__status--active': isActive.value },
              ])
                      }, null, 2),
                      _createElementVNode("h4", _hoisted_1, [
                        _renderSlot(_ctx.$slots, "title")
                      ])
                    ]),
                    _: 3
                  }),
                  (!__props.connecting)
                    ? _renderSlot(_ctx.$slots, "config", { key: 0 })
                    : _createCommentVNode("", true)
                ]),
                _: 3
              })
            ]),
            _: 3
          }),
          (_unref(slots).left && listening.value)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 0,
                span: "3 s:2",
                class: _normalizeClass({ 'base-module--disabled': !__props.contentActive })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "left")
                ]),
                _: 3
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_unref(slots).right && listening.value)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 1,
                span: "3 s:4",
                class: _normalizeClass({ 'base-module--disabled': !__props.contentActive })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "right")
                ]),
                _: 3
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_unref(slots).middle && listening.value)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 2,
                span: 6,
                class: _normalizeClass({ 'base-module--disabled': !__props.contentActive })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "middle")
                ]),
                _: 3
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_unref(slots).bottom && listening.value)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 3,
                span: 6,
                class: _normalizeClass({ 'base-module--disabled': !__props.contentActive })
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "bottom")
                ]),
                _: 3
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (!listening.value && __props.installed)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 4,
                span: 6
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('modules.notFound')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!listening.value && __props.installed)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 5,
                span: 6
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(BfButton), { onClick: subscribeToTopics }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('common.connection.reconnect')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!__props.installed)
            ? (_openBlock(), _createBlock(_unref(NGridItem), {
                key: 6,
                span: 6,
                class: _normalizeClass({ 'base-module--disabled': !__props.contentActive })
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NAlert), {
                    title: _unref(t)('modules.notAvailable.index'),
                    bordered: false
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_unref(Icon), {
                        icon: "mdi:information-outline",
                        style: { fontSize: '24px' }
                      })
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_unref(t)('modules.notAvailable.content')), 1)
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})